import { render, staticRenderFns } from "./mediaDetail.vue?vue&type=template&id=76df74a5&scoped=true&"
import script from "./mediaDetail.vue?vue&type=script&lang=js&"
export * from "./mediaDetail.vue?vue&type=script&lang=js&"
import style0 from "./mediaDetail.vue?vue&type=style&index=0&id=76df74a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76df74a5",
  null
  
)

component.options.__file = "mediaDetail.vue"
export default component.exports